export const logOutText = {
    ConfirmationText: {
        en: "Confirm logout",
        mr: "लॉगआउटची पुष्टी करा",
    },
    Message: {
        en: "Are you sure you want to log out?",
        mr: "आपण लॉगआउट करू इच्छिता याची खात्री आहे का?",
    },
    Cancel: {
        en: "Cancel",
        mr: "रद्द करा",
    },
    Logout: {
        en: "Log Out",
        mr: "लॉगआउट करा",
    },
};
